import axios from "axios";
import OperationTypes from "../types";
import { ServerSideTypes } from "../types/OperationCommonTypes";

export interface IReasonCodeCounter {
  code: string,
  description: string,
  total: number
}

const StatusReportAction = () => {
  const baseUrl = ``;

  const getStatusReportData = async (params: any) => {
    return await axios.get(`${baseUrl}/masterdatavehicle/stock`, {
      params: params,
    });
  };

  const exportStatusReportData = async (params: any) => {
    return await axios.get(`${baseUrl}/masterdatavehicle/stock/excel`, {
      params: params,
      responseType: "arraybuffer",
      headers: { "Access-Control-Allow-Origin": true },
    });
  };

  const getAllLocation = async (tenant: string) => {
    const fixedParams = { pageNumber: 0, pageSize: 1000000 };
    return await axios
      .get<ServerSideTypes.IResult<OperationTypes.Domain>>(
        "masterdatasupplier/location/locationsByFilters",
        {
          params: {
            tenant: tenant,
            pageNumber: fixedParams.pageNumber,
            pageSize: fixedParams.pageSize,
          },
        }
      )
      .then((response) => response.data.content);
  };

  const getAllTractionTypeData = async () => {
    return await axios.get(`${baseUrl}/masterdatavehicle/tractiontype/all`);
  };

  const getAllStatusReasonData = async (tenant: string) => {
    const fixedParams = { valid: true, pageNumber: 0, pageSize: 100000 };
    return axios
      .get<ServerSideTypes.IResult<OperationTypes.Domain>>(
        "masterdatavehicle/statusreason",
        {
          params: {
            tenant: tenant,
            valid: fixedParams.valid,
            pageNumber: fixedParams.pageNumber,
            pageSize: fixedParams.pageSize,
          },
        }
      )
      .then((response) => {
        return response.data.content;
      });
  };

  const getReasonCodeCounters = async (params: any) => {
    return await axios.get<IReasonCodeCounter[]>(`/masterdatavehicle/stock/reasonCodesCounters`, {
      params: {
        ...params,
      }
    }).then(
      (response) => {
        return response.data;
      }
    );
  }


  return {
    getStatusReportData,
    getAllLocation,
    getAllTractionTypeData,
    getAllStatusReasonData,
    exportStatusReportData,
    getReasonCodeCounters,
  };
};

export default StatusReportAction;
